import React from "react";
import {BarChart} from "@mui/x-charts";
import {TotalScoreByEmployeeResource} from "../../resources/dashboard.resource";

const valueFormatter = (value: number | null) => {
    if (value === null || value === undefined) {
        return '0%';
    }
    return `${Math.round(value)} %`;
}

interface IProps {
    totalScoreByEmployee: TotalScoreByEmployeeResource[],
}

const TotalScoreByEmployeesBarChart = ({totalScoreByEmployee}: IProps) => {
    return (
        <BarChart
            dataset={totalScoreByEmployee as Record<string, any>[]}
            yAxis={[
                {
                    valueFormatter: (value: number) => `${value}%`,
                },
            ]}
            xAxis={[{
                scaleType: 'band',
                dataKey: 'employeeName',
                labelStyle: {
                    fontSize: 12,
                },
                tickLabelStyle: {
                    angle: 45,
                    fontSize: 10,
                },
                height: 70,
            }]}
            series={[{
                id: 'completed',
                dataKey: 'completed',
                stack: 'indicators',
                color: '#7ECC8B',
                valueFormatter,
                label: 'Виконано'
            }, {
                id: 'notCompleted',
                dataKey: 'notCompleted',
                stack: 'indicators',
                color: '#E2ECF2',
                valueFormatter,
                label: 'Не виконано'
            }]}
            layout="vertical"
            height={700}
            borderRadius={20}
            grid={{horizontal: true}}
            hideLegend={true}
        />
    );
};

export default TotalScoreByEmployeesBarChart;
